import {Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import {AuthService, ConfigurationService} from "@fedeltapointofsale/data-client";

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private router: Router,
                private authService: AuthService,
                private configService: ConfigurationService) {
    }

    canActivate() {
        if (this.authService.isLoggedIn()) {
            // logged in so return true
            this.configService.setContext("userId", this.authService.getLoggedInUserId().toString());
            this.configService.setContext("role", this.authService.getLoggedInRole());
            return true;
        }

        // not logged in so redirect to login page
        this.router.navigate(["/login"]);
        return false;
    }
}
